export default "/images/vendor/flag-icon-css/flags/4x3/mm.svg?7548e5caee7b970d0859b5beef33c3a3";